exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb_20[data-v-2ce20ee0] {\n  margin-bottom: 0.104167rem;\n}\n.label[data-v-2ce20ee0] {\n  margin-bottom: 0.052083rem;\n}\n[data-v-2ce20ee0] .el-dialog {\n  width: 3.125rem;\n}", ""]);

// exports
